import React from "react";

import Avatar from "react-avatar";
import { toastr } from "react-redux-toastr";

import Button from "../Button.jsx";

function ImageInput({ label, image, field, onChange }) {
  function convertToBase64(e, callback) {
    const file = e.target.files[0];

    if (file.size > 16000000) {
      callback(false);
    }
    if (file != undefined) {
      if (file.size > 200000) {
        callback(false);
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        callback(reader.result, file.size, file);
      };

      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    }
  }

  return (
    <div>
      <label style={{ marginLeft: "14px" }}>{label}</label>

      <div className="avatar-foto-perfil">
        <Avatar src={image || ""} size="100" style={{ marginLeft: "10px" }} />
        <Button
          className="btn-danger"
          icon="fa-trash"
          style={{ marginLeft: "5px" }}
          onClick={() =>
            onChange({
              image: null,
              field: field,
            })
          }
        />

        <label htmlFor={field} className="btn btn-primary">
          <i class="fa fa-search" aria-hidden="true"></i>
        </label>

        <input
          type="file"
          id={field}
          style={{ visibility: "hidden" }}
          accept="image/png"
          onChange={(e) => {
            convertToBase64(e, (result, size, file) => {
              if (!result) {
                toastr.error(
                  "Arquivo muito grande!",
                  "Recomendamos que seja uma foto de no máximo 16MB."
                );
              } else {
                onChange({
                  image: result,
                  field: field,
                  file: file,
                });
              }
            });
          }}
        />
      </div>
    </div>
  );
}

export default ImageInput;



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/ImageInput/index.jsx